<template>
  <div class="nav-bar-container">
    <div style="background-image:linear-gradient(to right, #00C0C1 , #01D3B7);height:100%;line-height:100%;"><img
        src="/static/images/logo1.png" class="logo-img" alt=""></div>
    <div class="font-22-e2" style="margin-left:40px;margin-right:40px;">小钉erp管理系统</div>
    <el-select class="nav-bar-select" @change="selectCompany" v-model="value" placeholder="请选择">
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
    <div class="flex-1 flex align-center justify-end">
      <img :src="user.gender === 1 ? '/static/images/boy.png' : '/static/images/girl.png'" class="avatar-img" alt="">
      <div class="font-16-ff mr-10">{{user.name}}</div>
      <div class="font-12-85 text-left">{{user.departmentName}} {{user.roleName}}</div>
      <div class="flex align--center cursor ml-12" @click="toMessage">
        <img src="/static/images/xiaoxi.png" class="icon-16" alt="">
        <div class="tip-round-ff5555 mr-20" v-if="messageList.length>0">{{messageList.length}}</div>
      </div>
      <img src="/static/images/shezhi.png" @click="onChangePwd" class="icon-16 cursor ml-12" alt="">
    </div>
    <div class="pl-20">
      <div class="btn-24-bg-46b8b0 flex align-center" @click="toQuit">
        <img src="/static/images/tuichu.png" style="margin-right: 5px;" class="icon-16" alt="">
        <span>退出</span>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'NavBar',
  components: {},
  data () {
    return {
      user: this.$store.state.user || {},
      options: [],
      value: '',
      messageList: []
    }
  },
  watch: {
    value: function (val) {
      let that = this
      this.$store.dispatch('setCompanyId', val).then(() => {
        that.$emit('on-refresh')
      })
    }
  },
  created () {
    let flag = false
    this.options = this.$store.state.companyList
    this.options.forEach(item => {
      if (parseInt(item.id) === parseInt(this.$store.state.companyId)) {
        if (typeof item.id === 'number') {
          this.value = parseInt(this.$store.state.companyId)
        } else {
          this.value = this.$store.state.companyId
        }
        flag = true
      }
    })
    if (!flag) {
      this.value = this.$store.state.user.companyId
    }
    this.getMessage()
  },
  mounted () {
  },
  methods: {
    selectCompany (e) {
      if (this.$store.state.companyId !== e) {
        this.$router.go(0)
      }
    },
    getMessage () {
      this.messageList = []
      let param = {
        remindId: this.$store.state.user.id,
        remindType: 1,
        isRead: 0,
        status: 1
      }
      this.axios.post('message/list', param).then(res => {
        if (res.data.success) {
          this.messageList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    onChangePwd () {
      this.$emit('on-change-pwd')
    },
    toMessage () {
      // this.$store.dispatch('setNotice', 2)
      this.$parent.$refs.message.messageVisible = true
      // this.$parent.$refs.message.getNotice()
    },
    toQuit: function () {
      this.$store.dispatch('removeUser', {})
      this.$router.replace('/login')
    }
  }
}
</script>

<style lang="scss" scoped>
.logo-img {
  width: 250px;
  height: 100%;
}

.nav-bar-container {
  width: 100%;
  height: 68px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
  background: #292D36;
  // background: url("/static/images/topbg.png") no-repeat center;
  background-size: 100% auto;
  line-height: 68px;
  display: flex;
  padding: 0 40px 0 0;
  align-items: center;
  z-index: 8;

  .border {
    border-left: 1px solid #f3f4f7;
    border-right: 1px solid #f3f4f7;
    height: 100%;
    margin-left: 20px;
    padding: 0 20px;
  }

  .avatar-img {
    width: 34px;
    height: 34px;
    border-radius: 99px;
    border: 1px solid #e5e5e5;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue